export const tabCount = {
  xl: 3,
  lg: 3,
  md: 1,
  sm: 0,
}

export const steps = ['Setup & Schedule', 'Surveys', 'Select Audience', 'Order Summary']

export const stepIndexes = {
  testSetup: 0,
  survey: 1,
  audience: 2,
  order: 3,
}

export const choiceTypes = {
  multipleChoice: 0,
  openEnded: 1,
  openEndedNumeric: 2,
  totalFaultPercentage: 3,
}

export const questionTypeOptions = [
  {value: choiceTypes.multipleChoice, label: 'Multiple Choice'},
  {value: choiceTypes.totalFaultPercentage, label: 'Total Fault Percentage'},
  {value: choiceTypes.openEnded, label: 'Open Ended'},
  {value: choiceTypes.openEndedNumeric, label: 'Open Ended Numeric'},
]

export const followUpQuestionTypeOptions = [
  {value: choiceTypes.openEnded, label: 'Open Ended'},
  {value: choiceTypes.openEndedNumeric, label: 'Open Ended Numeric'},
]

export const testTypes = {
  legal: '0',
  creative: '1',
}

export const defaultSurveyQuestionTypes = {
  legalValuation: '0',
  legalLiability: '1',
  creative: '2',
}

export const questionTypeAvailability = {
  [choiceTypes.multipleChoice]: {
    allowedTestTypes: [testTypes.legal, testTypes.creative],
  },
  [choiceTypes.openEnded]: {
    allowedTestTypes: [testTypes.legal, testTypes.creative],
  },
  [choiceTypes.openEndedNumeric]: {
    allowedTestTypes: [testTypes.legal, testTypes.creative],
  },
  [choiceTypes.totalFaultPercentage]: {
    allowedTestTypes: [testTypes.legal],
  },
}

// deliberately no litigation entry: premium-report entitlement follows the
// CaseType record's autoPremiumReport flag, never a hardcoded name
export const caseTypes = {
  valuation: 'Valuation',
}

export const testNameMaxLength = 58

export const groupNameMaxLength = 40

export const minQuestionLength = 10

export const maxMoments = 8

export const defaultTimezone = 'America/New_York'

export const contextFields = {
  timezone: 'timezone',
  startDate: 'startDate',
  videoFile: 'videoFile',
  testName: 'testName',
  testType: 'testType',
  audienceGroups: 'audienceGroups',
  questions: 'questions',
  caseType: 'caseType',
  objectives: 'objectives',
  moments: 'moments',
  paymentProcessed: 'paymentProcessed',
  coreIssue: 'coreIssue',
  intendedObjectives: 'intendedObjectives',
}

export const costs = {
  test: 600,
  surveyQuestion: 2,
  premiumReport: 1200,
}

export const questionTypes = {
  0: {label: 'Multiple Choice Question', value: 'multiple-choice'},
  1: {label: 'Open Ended Answer', value: 'text'},
  2: {label: 'Open Ended Numeric Answer', value: 'text', subType: 'numeric'},
  3: {label: 'Total Fault Percentage', value: 'text', subType: 'total-fault-percentage'},
}

export const questionSubTypesToTypeMap = {
  0: 0, // multipleChoice -> multipleChoice
  1: 1, // openEnded -> openEnded
  2: 1, // openEndedNumeric -> openEnded
  3: 1, // totalFaultPercentage -> openEnded
}

export const objectiveTypes = {
  survey: 0,
}

export const errorModalTexts = {
  invalidData: 'You have invalid data in your test. Please change before continuing!',
  unsavedData: 'You have unsaved changes. Please save your changes before continuing',
}

export const lucidGenderId = 43
